import PlayerUrlChecker from './PlayerUrlChecker';
import withSvpPlayer from './withSvpPlayer';
import Player, { PLAYER_STATE } from './Player';

export const PurePlayer = withSvpPlayer(Player);

export { PLAYER_STATE };

export default withSvpPlayer(PlayerUrlChecker);
